import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRouting } from '../../../utils/useRouting';
import API from '@aws-amplify/api';
import Grid from '@material-ui/core/Grid';
import EmiconMesstermin from './EmiconMesstermin';
import Container from '@material-ui/core/Container';
import EmiconMessbericht from './EmiconMessbericht';
import EmiconVertragsEnde from './EmiconVertragsEnde';
import EmiconVertragsArten from './EmiconVertragsArten';
import EmiconServiceGeplant from './EmiconServiceGeplant';
import EmiconWartungGeplant from './EmiconWartungGeplant';
import EmiconKatWechselGeplant from './EmiconKatWechselGeplant';
import EmiconVertragsKommentar from './EmiconVertragsKommentar';
import SetupHeader from '../../../emilog/components/SetupHeader';
import EmiconServiceAbgeschlossen from './EmiconServiceAbgeschlossen';
import EmiconWartungAbgeschlossen from './EmiconWartungAbgeschlossen';
import EmiconKatWechselAbgeschlossen from './EmiconKatWechselAbgeschlossen';
// import { Emicon } from '../../../../types/Device';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiFilledInput-input': {
      padding: '6px 20px 6px 8px',
    },
    '.MuiCardHeader-action': {
      margin: 0,
    },
  },
  content: {
    marginTop: theme.spacing(1),
    flex: 1,
  },
  container: {
    width: '85vw',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      width: '90vw',
    },
  },
  expandingCard: {
    display: 'flex',
    flexGrow: 1,
  },
}));

export default function EmiconEinstellungen() {

  /* Service */

  const { currentDevice, setCurrentDevice, fetchDevices } = useRouting('Service', true); // TODO? Evtl. currentDevice an Komponenten rutnerreichen

  const classes = useStyles();

  const [hasWartungPlanned, setHasWartungPlanned] = useState<boolean | null>(null);
  const [lastWartungPlannedDate, setLastWartungPlannedDate] = useState<number | null>(null);

  const [hasServicePlanned, setHasServicePlanned] = useState<boolean | null>(null);
  const [lastServicePlannedDate, setLastServicePlannedDate] = useState<number | null>(null);

  const [hasKatPlanned, setHasKatPlanned] = useState<boolean | null>(null);
  const [lastKatPlannedDate, setLastKatPlannedDate] = useState<number | null>(null);

  async function checkHasActiveWartung() {
    if (currentDevice.serialNumber === null || currentDevice.serialNumber === undefined) {
      return;
    }
    const result = await API.post('emilog', 'hasServicePlanned', {
      body: {
        serialNumber: currentDevice.serialNumber,
        isEmicon: true,
        isWartung: true // ACHTUNG
      },
    });
    setHasWartungPlanned(result.hasWartungPlanned ?? false);
    setLastWartungPlannedDate(result.lastWartungPlannedDate ?? 0);
  }

  async function checkHasActiveService() {
    if (currentDevice.serialNumber === null || currentDevice.serialNumber === undefined) {
      return;
    }
    const result = await API.post('emilog', 'hasServicePlanned', {
      body: {
        serialNumber: currentDevice.serialNumber,
        isEmicon: true,
      },
    });
    setHasServicePlanned(result.hasServicePlanned ?? false);
    setLastServicePlannedDate(result.lastServicePlannedDate ?? 0);
  }

  async function checkHasActiveKatWechsel() {
    if (currentDevice.serialNumber === null || currentDevice.serialNumber === undefined) {
      return;
    }
    const result = await API.post('emilog', 'hasServicePlanned', {
      body: {
        serialNumber: currentDevice.serialNumber,
        isEmicon: true,
        isKat: true // ACHTUNG
      },
    });
    setHasKatPlanned(result.hasKatWechselPlanned ?? false);
    setLastKatPlannedDate(result.lastKatWechselPlannedDate ?? 0);
  }

  useEffect(() => {
    checkHasActiveWartung();
    checkHasActiveService();
    checkHasActiveKatWechsel();
  }, [currentDevice.serialNumber]);

  // console.log({ currentDevice })

  return (
    <Container className={classes.container} maxWidth="xl">
      <SetupHeader isEmicon hasBearbeitung={true} />
      <Grid container spacing={2} className={classes.content} justifyContent="center">

        <Grid item lg={6} className={classes.expandingCard}>

          <Grid container spacing={2} justifyContent="space-between">

            <Grid item xs={6}>
              <EmiconWartungGeplant hasWartungPlanned={hasWartungPlanned} lastWartungPlannedDate={lastWartungPlannedDate} />
            </Grid>

            <Grid item xs={6}>
              <EmiconWartungAbgeschlossen serialNumber={currentDevice.serialNumber} hasWartungPlanned={hasWartungPlanned} lastWartungPlannedDate={lastWartungPlannedDate} fetchDevices={fetchDevices} />
            </Grid>

            <Grid item xs={6}>
              <EmiconServiceGeplant hasServicePlanned={hasServicePlanned} lastServicePlannedDate={lastServicePlannedDate} />
            </Grid>

            <Grid item xs={6}>
              <EmiconServiceAbgeschlossen serialNumber={currentDevice.serialNumber} hasServicePlanned={hasServicePlanned} lastServicePlannedDate={lastServicePlannedDate} />
            </Grid>

            <Grid item xs={6}>
              <EmiconKatWechselGeplant hasKatPlanned={hasKatPlanned} lastKatPlannedDate={lastKatPlannedDate} />
            </Grid>

            <Grid item xs={6}>
              <EmiconKatWechselAbgeschlossen serialNumber={currentDevice.serialNumber} hasKatPlanned={hasKatPlanned} lastKatPlannedDate={lastKatPlannedDate} />
            </Grid>

            <Grid item xs={6}>
              <EmiconMessbericht />
            </Grid>

            <Grid item xs={6}>
              <EmiconMesstermin
                serialNumber={currentDevice.serialNumber}
                isEmicon={true}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
                fetchDevices={fetchDevices}
              />
            </Grid>


          </Grid>

        </Grid>



        <Grid item lg={6} className={classes.expandingCard}>

          <Grid container spacing={2} justifyContent="space-between">


            <Grid item xs={6}>
              <EmiconVertragsArten serialNumber={currentDevice.serialNumber} isEmicon={true} />
            </Grid>

            <Grid item xs={6}>
              <EmiconVertragsEnde serialNumber={currentDevice.serialNumber} isEmicon={true} />
            </Grid>

            <Grid item xs={12} >
              <EmiconVertragsKommentar serialNumber={currentDevice.serialNumber} isEmicon={true} />
            </Grid>

          </Grid>


        </Grid>

      </Grid>
    </Container >
  );
}
